import $ from 'jquery';
import formatContent from './formatContent';

export default () => {
  $(document).on('shopify:section:load', (e) => {
    formatContent(`[data-section-id="${e.detail.sectionId}"]`);
  });
};